import { render, staticRenderFns } from "./OfertaEdicaoRapida.vue?vue&type=template&id=425bed11&scoped=true&"
import script from "./OfertaEdicaoRapida.vue?vue&type=script&lang=js&"
export * from "./OfertaEdicaoRapida.vue?vue&type=script&lang=js&"
import style0 from "./OfertaEdicaoRapida.vue?vue&type=style&index=0&id=425bed11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425bed11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VListItem,VListItemContent,VMenu,VRow,VSwitch})
